// extracted by mini-css-extract-plugin
module.exports = {"caption":"BasicContentFullWidthImage_caption__E6Rk7","image":"BasicContentFullWidthImage_image__fm_zU","search-fade-in":"BasicContentFullWidthImage_search-fade-in__CJRal"};